import { render, staticRenderFns } from "./cycscqycxqkb.vue?vue&type=template&id=ff33963a&scoped=true&"
import script from "./cycscqycxqkb.vue?vue&type=script&lang=js&"
export * from "./cycscqycxqkb.vue?vue&type=script&lang=js&"
import style0 from "./cycscqycxqkb.vue?vue&type=style&index=0&id=ff33963a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff33963a",
  null
  
)

export default component.exports